import { AppThunk } from '../../../store/rootReducer';
import { userSelector } from '../../auth/selectors/auth.selectors';
import { loadDelineations } from '../../delineation/thunks/load-delineations.thunk';
import { loadDiagnostics } from '../../diagnostic/thunks/load-diagnostics.thunk';
import * as metricActions from '../../metric/actions/metric.actions';
import { loadRawSignal } from '../../raw-signal/thunks/load-raw-signal.thunk';
import { loadStripOnsets } from '../../scatter/thunks/load-strip-onsets.thunk';
import * as ecgActions from '../actions/ecg.actions';
import * as ecgClient from '../clients/ecg.client';
import { isEcgAlreadyProcessed } from '../utils/ecg.utils';
import { loadILRImage } from './load-ilr-image.thunk';
import { loadSignal } from './load-signal.thunk';
import { loadStripInfo } from './load-strip-info.thunk';
import * as analyticsInfoActions from '../../analytics/actions/analytics-info.actions';
import { DateTime } from 'luxon';

export const loadData =
  (ecgId: string): AppThunk =>
  async (dispatch, getState) => {
    const ecg = await ecgClient.getEcg(ecgId);
    const user = userSelector(getState());

    if (user == null) {
      throw new Error('user is missing');
    }

    if (ecg == null) {
      throw new Error('ecg is missing');
    }

    dispatch(
      ecgActions.loaded({
        ecg: {
          analysisType: ecg.analysisType,
          recordType: ecg.recordType,
          duration: ecg.duration,
          ecgId,
          errorType: ecg.errorType,
          patientInfo: ecg.patientInfo,
        },
        meta: { history: false },
      }),
    );

    if (isEcgAlreadyProcessed(ecg.analysisType)) {
      dispatch(
        analyticsInfoActions.setEcgTimeStarted({
          timestamp: DateTime.now().toMillis(),
        }),
      );
      dispatch(loadSignal(ecgId));
      dispatch(loadRawSignal(ecgId));
      dispatch(
        metricActions.loaded({
          metrics: ecg.dashboardMeasurements,
          meta: { history: false },
        }),
      );

      dispatch(loadDelineations(ecg.delineations));
      dispatch(loadDiagnostics(ecg.diagnostics));
      dispatch(loadStripInfo(ecg.stripInfo));
      dispatch(loadStripOnsets(ecg.stripInfo));
      dispatch(loadILRImage(ecg.id));
    }
  };
